(() => {
  class TextCollection extends HTMLElement {
    constructor() {
      super();
      this.moreBtn = this.querySelector(".js-text-collection-weiterlesen");
      this.hiddenContent = this.querySelector(".js-hidden-content-tc");
    }

    connectedCallback() {
      if (this.moreBtn) {
        this.moreBtn.addEventListener("click", () => {
          this.hiddenContent.style.maxHeight = `${this.hiddenContent.scrollHeight}px`;
          this.moreBtn.classList.add("opacity-0", "pointerevents-none");
        });
      }
    }
  }

  if (!customElements.get("text-collection")) {
    customElements.define("text-collection", TextCollection);
  }
})();
